'use client';

import React, { useEffect } from 'react';
import Link from 'next/link';
import { toPascalCase } from '../../utils/changeCase';
import styles from './styles.module.scss';
import { constructClassName } from '../../utils/constructClassName';
import { eventEmitter } from '../../lib/eventEmitter';

interface Props {
  sections: string[];
}

export const TableOfContents: React.FC<Props> = ({
  sections,
}) => {
  const [activeSection, setActiveSection] = React.useState<string | null>(null);

  useEffect(() => {
    const handleBlockIntersect = (slug: string) => {
      setActiveSection(slug);
    };

    eventEmitter.on('blockIntersect', handleBlockIntersect);

    return () => {
      eventEmitter.off('blockIntersect', handleBlockIntersect);
    };
  }, []);

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Table Of Contents</h2>
      {
        sections.map((section) => (
          <Link
            key={section}
            className={constructClassName([
              styles.link,
              activeSection === toPascalCase(section).toLowerCase() && styles.activeLink,
            ])}
            href={`#${toPascalCase(section).toLowerCase()}`}
          >
            {section}
          </Link>
        ))
      }
    </div>
  );
};
